<template>
  <vxe-pager
    class="pager-v2"
    size="small"
    background
    :current-page.sync="pagerConfig.page"
    :page-size.sync="pagerConfig.limit"
    :total="pagerConfig.total"
    :page-sizes="pageSizes"
    :layouts="['PrevPage', 'JumpNumber', 'NextPage', 'Sizes', 'Total']"
    @page-change="pageChange"
    v-bind="$attrs">
    <div slot="right" v-if="showPageSize">
      <vxe-input v-model="limitCustom" size="small" @change="pageSizeChange" style="width: 80px" @keyup.enter.native="pageSizeSubmit"></vxe-input>
    </div>
  </vxe-pager>
</template>

<script>
  export default {
    name: "BspPagination",
    props: {
      pagerConfig: {
        type: Object,
        default() {
          return {
            page: 1,
            limit: 20,
            total: 0
          }
        }
      },
      pageSizes: {
        type: Array,
        default() {
          return  [10, 20, 50, 100]
        }
      },
      showPageSize: {
        type: Boolean,
        default: false
      }
    },
    data() {
      return {
        limitCustom: 1
      }
    },
    methods:{
      pageChange(val) {
        const { type, currentPage, pageSize } = val;
        const pagerConfig = {
          page: type == 'size' ? 1 : currentPage,
          limit: pageSize,
          type
        }
        this.$emit('update:pagerConfig', {
          ...this.pagerConfig,
          ...pagerConfig
        })
        this.$emit('page-change', pagerConfig)
      },
      pageSizeChange({ value }) {
        this.limitCustom = this.limitCustom.replace(/[^0-9]/ig, '');
        if (this.limitCustom > 1000000) {
          this.limitCustom = 1000000;
        }
        if (this.limitCustom < 1) {
          this.limitCustom = 1;
        }
      },
      // 输入框回车，调接口
      pageSizeSubmit() {
        this.$emit('page-size-change', {
          ...this.pagerConfig,
          page: 1,
          limit: Number(this.limitCustom),
          total: 0
        })
      }
    }
  }
</script>

<style scoped>

</style>
